<template>
	<paginated-search v-bind="{ schema, searchEntities, openEntity, createEntity, autoEnable: true }"></paginated-search>
</template>

<script>
	import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
	import Article from "@/models/article.model.vue";

	export default {
		components: {
			PaginatedSearch,
		},
		data () {
			return {
				schema: Article.getSchema(),
			};
		},
		methods: {
			openEntity(entity) {
				this.$router.push(`/artigos/${entity.id}`);
			},
			createEntity() {
				this.$router.push(`/artigos/novo`);
			},
			searchEntities(paginationParameters) {
				return Article.search(paginationParameters);
			},
		},
	}
</script>